import React, { forwardRef, useEffect } from 'react';
import { isArray } from 'lodash'
import { AspectRatio } from '@chakra-ui/react';

import Box from './Box'
import useWebpImage from './utils/useWebpImage';

const BGImage = ({ src, children, onLoad, ...props }) => {
  const pic = useWebpImage(src)
  const [loadedSrc, setLoadedSrc] = React.useState('')
  useEffect(() => {
    const s = isArray(src) ? pic : src
    const bgImg = new Image();
    bgImg.onload = () => {
      if (onLoad) onLoad()
      setLoadedSrc(s)
    };
    bgImg.src = s;
  }, [src])
  return (
    <Box
      backgroundImage={`url(${loadedSrc})`}
      {...props}
    >
      {children && (
        <Box.FullAbs>{children}</Box.FullAbs>
      )}
    </Box>
  )
}

BGImage.defaultProps = {
  backgroundSize: 'cover',
  backgroundPosition: '50% 50%',
  backgroundRepeat: 'no-repeat',
};

const BackgroundImage = forwardRef(({
  src,
  children,
  backgroundSize,
  backgroundPosition,
  onLoad,
  ...props
}, ref) => (
  <AspectRatio {...props} ref={ref}>
    <BGImage
      src={src}
      backgroundSize={backgroundSize}
      backgroundPosition={backgroundPosition}
      onLoad={onLoad}
    >{children}</BGImage>
  </AspectRatio>
));

BackgroundImage.displayName = 'BackgroundImage';

export default BackgroundImage
